module.exports = __webpack_public_path__ + "BN.png?fec59b5eb3c85c953fd02a20f0df0b06";